const NOTIFICATION_REFETCH_INTERVAL_MS = 2000;

type TParams = {
  workspaceListChanged: boolean;
  notificationsReceived: boolean;
  msSinceLastFetch: number;
};

export const shouldRefetchWorkspaces = ({ workspaceListChanged, notificationsReceived, msSinceLastFetch }: TParams) =>
  workspaceListChanged || (notificationsReceived && msSinceLastFetch >= NOTIFICATION_REFETCH_INTERVAL_MS);
